import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useOutsourceQuery, useUpdateOutsource } from "../api/queries";
import { OutsourceForm } from "../ui/OutsourceForm";

export function OutsourceEditPage() {
  const { id } = useParams({ from: "/app/performance/outsources/$id/edit" });
  const nav = useNavigate({ from: "/app/performance/outsources/$id/edit" });
  const query = useOutsourceQuery(id);
  const updateOutsource = useUpdateOutsource(id);

  if (query.isLoading) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              { label: "Outsource", to: "/app/performance/outsources" },
              { label: "..." },
            ]}
          />
        </Header>
        <Main>
          <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
        </Main>
      </>
    );
  }

  if (!query.data) {
    return (
      <>
        <Header>
          <Breadcrumb
            items={[
              { label: "Outsource", to: "/app/performance/outsources" },
              { label: "ບໍ່ພົບ" },
            ]}
          />
        </Header>
        <Main>
          <p className="text-destructive">ບໍ່ພົບ Outsource</p>
        </Main>
      </>
    );
  }

  const row = query.data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Outsource", to: "/app/performance/outsources" },
            { label: row.displayName },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">{row.displayName}</h2>
          <p className="text-muted-foreground">ແກ້ໄຂ master Outsource</p>
        </div>

        <div className="mx-auto max-w-3xl rounded-xl border bg-card px-4 sm:px-6">
          <OutsourceForm
            isEdit
            initialValues={{
              categoryId: row.categoryId,
              payeeType: row.payeeType,
              displayName: row.displayName,
              contactName: row.contactName ?? "",
              phone: row.phone ?? "",
              email: row.email ?? "",
              bankName: row.bankName ?? "",
              bankAccount: row.bankAccount ?? "",
              bankAccountName: row.bankAccountName ?? "",
              notes: row.notes ?? "",
              status: row.isActive ? "active" : "inactive",
            }}
            onSubmit={async (vals) => {
              try {
                await updateOutsource.mutateAsync({
                  categoryId: vals.categoryId,
                  payeeType: vals.payeeType,
                  displayName: vals.displayName,
                  contactName: vals.contactName ?? null,
                  phone: vals.phone?.trim() || null,
                  email: vals.email?.trim() || null,
                  bankName: vals.bankName?.trim() || null,
                  bankAccount: vals.bankAccount?.trim() || null,
                  bankAccountName: vals.bankAccountName?.trim() || null,
                  notes: vals.notes?.trim() || null,
                  isActive: vals.status === "active",
                });
                nav({ to: "/app/performance/outsources" });
              } catch {}
            }}
            onCancel={() => nav({ to: "/app/performance/outsources" })}
            submitting={updateOutsource.isPending}
          />
        </div>
      </Main>
    </>
  );
}
